import {
  Component,
  ChangeDetectionStrategy,
  inject,
  Signal,
  OnInit,
  effect,
  OnDestroy,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Exchange,
  ExchangesService,
  Winner,
  WinnersResponse,
} from '../services/exchanges.service';

interface Paginator {
  total?: number;
  currentPage?: number;
  pages?: number;
}

@Component({
  selector: 'app-giveaway-info',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTableModule, MatPaginatorModule, DateFormatPipe ],
  templateUrl: './giveaway-info.component.html',
  styleUrls: ['./giveaway-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GiveawayInfoComponent implements  OnInit, OnDestroy {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private readonly exchangesService = inject(ExchangesService);
  private paginatorSubscription: Subscription | null = null;

  public readonly exchanges: Signal<Exchange[]> = this.exchangesService.getExchanges();
  public readonly winners: Signal<WinnersResponse | null> = this.exchangesService.getWinners();
  public paginatorSignal = signal<Paginator>({});
  public readonly exchangeColumns = signal<Exchange[][]>([[], [], []]);

  public displayedColumns: string[] = [
    'position',
    'username',
    'amount',
    'exchange_name',
    'date_won',
  ];

  public dataSource = new MatTableDataSource<Winner>([]);


  constructor() {
    this.registerCustomIcons();

    effect(() => {
      const data = this.winners();
      if (data) {
        this.dataSource.data = data.winners;
        this.paginatorSignal.set({total: data.total, pages: data.pages, currentPage: data.page})
      }
    });

    effect(() => {
      const allExchanges = this.exchanges() || [];
      this.exchangeColumns.set(this.distributeExchanges(allExchanges));
    });
  }

  ngOnInit() {
    const winnersData = this.winners()?.winners || [];
    this.dataSource.data = winnersData;
    

  }



  ngOnDestroy() {
    // Отписываемся от событий при уничтожении компонента
    if (this.paginatorSubscription) {
      this.paginatorSubscription.unsubscribe();
    }
  }

  private distributeExchanges(items: Exchange[]): Exchange[][] {
  const columns: Exchange[][] = [[], [], []];
  const baseCount = Math.floor(items.length / 3);
  const remainder = items.length % 3;
  const copy = [...items];

  // заполняем базу
  for (let i = 0; i < 3; i++) {
    columns[i] = copy.splice(0, baseCount);
  }

  // весь остаток кидаем во 2 колонку
  for (let i = 0; i < remainder; i++) {
    columns[1].push(copy.shift()!);
  }

  return columns;
}


 private registerCustomIcons() {
    this.iconRegistry.addSvgIcon(
      'twitch',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/twitch.svg')
    );
    this.iconRegistry.addSvgIcon(
      'youtube',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/youtube.svg')
    );
    this.iconRegistry.addSvgIcon(
      'logo',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/logo.svg')
    );
    this.iconRegistry.addSvgIcon(
      'x',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/x.svg')
    );
    this.iconRegistry.addSvgIcon(
      'merch',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/merch.svg')
    );
    this.iconRegistry.addSvgIcon(
      'discord',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/discord.svg')
    );
    this.iconRegistry.addSvgIcon(
      'background',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/give-away-background.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'Blofin',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Blofin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'BingX',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/BingX.svg')
    );
    this.iconRegistry.addSvgIcon(
      'BitUnix',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/BitUnix.svg')
    );
    this.iconRegistry.addSvgIcon(
      'Toobit',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/TooBit.svg')
    );
    this.iconRegistry.addSvgIcon(
      'MEXC',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/MEXC.svg')
    );
    this.iconRegistry.addSvgIcon(
      'KCEX',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Kcex.svg')
    );
    this.iconRegistry.addSvgIcon(
      'Hyperliquid',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/Hyperliquid.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'BTCC',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/BTCC.svg')
    );

    this.iconRegistry.addSvgIcon(
      'YuBit',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/YuBit.svg')
    );

    this.iconRegistry.addSvgIcon(
      'left-arrow',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/left-arrow.svg')
    );

    this.iconRegistry.addSvgIcon(
      'right-arrow',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/right-arrow.svg')
    );

    this.iconRegistry.addSvgIcon(
      'Kimba NFT',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/kimba.svg')
    );
    
    this.iconRegistry.addSvgIcon(
      'WEEX',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Weex.svg')
    );
  }

// formatDate(timestamp: number): string {
 
//   return new Date(timestamp * 1000).toLocaleDateString();
// }

  nextPage() {
    const winnersData = this.winners();
    if (winnersData) {
      const nextPage = winnersData.page + 1;
      if (nextPage <= winnersData.pages) {
        this.exchangesService.loadWinners(nextPage, 20);
      }
    }
  }

  loadWinners(pageNumber: number) {
    this.exchangesService.loadWinners(pageNumber, 20);
  }

  prevPage() {
    const winnersData = this.winners();
    if (winnersData) {
      const prevPage = winnersData.page - 1;
        console.log(prevPage)
      if (prevPage >= 1) {
        this.exchangesService.loadWinners(prevPage, 20);
      }
    }
  }

 countListPosition(): string {
  const winnersData = this.winners();
  if (!winnersData) return '0-0 из 0';
  
  const { total, page, pages } = winnersData;
  const pageSize = 20; 
  
  const start = (page - 1) * pageSize + 1;
  let end = page * pageSize;

  if (end > total) {
    end = total;
  }
  
  return `${start} - ${end} of ${total}`;
} 

calculatePosition(index: number): number {
  const winnersData = this.winners();
  if (!winnersData) return index + 1;
  
  const currentPage = winnersData.page;
  const pageSize = 20;
  
  return (currentPage - 1) * pageSize + index + 1;
}
}